import {
    RebuildLayoutAction,
    LayoutCalculatedEffect,
    LayoutCalculationStartedEffect,
    SettingsChangedAction,
    NodesMovedAction,
    QueryGraphAction,
    QueryGraphEffect,
    SelectionChangedAction,
    SelectionChangedEffect,
    HiddenNodesChangedAction,
    HiddenNodesVisibilityChangedAction,
    ListResultSelectedAction
} from './interface';

export function isAction(
    actionOrEffect?: QueryGraphAction | QueryGraphEffect
): actionOrEffect is QueryGraphAction {
    if (!actionOrEffect) {
        return false;
    }

    return (actionOrEffect as QueryGraphAction).actionType !== undefined;
}

export function isNodesMovedAction(
    actionOrEffect: QueryGraphAction | QueryGraphEffect
): actionOrEffect is NodesMovedAction {
    return (actionOrEffect as QueryGraphAction).actionType === 'MOVED_NODES';
}

export function isRebuildLayoutAction(
    actionOrEffect: QueryGraphAction | QueryGraphEffect
): actionOrEffect is RebuildLayoutAction {
    return (actionOrEffect as QueryGraphAction).actionType === 'REBUILD_LAYOUT';
}

export function isSettingsChangedAction(
    actionOrEffect: QueryGraphAction | QueryGraphEffect
): actionOrEffect is SettingsChangedAction {
    return (actionOrEffect as QueryGraphAction).actionType === 'SETTINGS_CHANGED';
}

export function isViewKindChangedAction(action: SettingsChangedAction) {
    return action.oldViewKind !== action.newViewKind;
}

export function isHiddenNodesChangedAction(
    actionOrEffect: QueryGraphAction | QueryGraphEffect
): actionOrEffect is HiddenNodesChangedAction {
    return (actionOrEffect as QueryGraphAction).actionType === 'HIDDEN_NODES_CHANGED';
}

export function isHiddenNodesVisibilityChangedAction(
    actionOrEffect: QueryGraphAction | QueryGraphEffect
): actionOrEffect is HiddenNodesVisibilityChangedAction {
    return (actionOrEffect as QueryGraphAction).actionType === 'HIDDEN_NODES_VISIBILITY_CHANGED';
}

export function isSelectionChangedAction(
    actionOrEffect: QueryGraphAction | QueryGraphEffect
): actionOrEffect is SelectionChangedAction {
    return (actionOrEffect as QueryGraphAction).actionType === 'SELECTION_CHANGED';
}

export function isListResultSelectedAction(
    actionOrEffect: QueryGraphAction | QueryGraphEffect
): actionOrEffect is ListResultSelectedAction {
    return (actionOrEffect as QueryGraphAction).actionType === 'LIST_RESULT_SELECTED';
}

export function isSelectionChangedEffect(
    actionOrEffect: QueryGraphAction | QueryGraphEffect
): actionOrEffect is SelectionChangedEffect {
    return (actionOrEffect as QueryGraphEffect).effectType === 'SELECTION_CHANGED';
}

export function isLayoutCalculatingStartedEffect(
    actionOrEffect: QueryGraphAction | QueryGraphEffect
): actionOrEffect is LayoutCalculationStartedEffect {
    return (actionOrEffect as QueryGraphEffect).effectType === 'LAYOUT_CALCULATION_STARTED';
}

export function isLayoutCalculatedEffect(
    actionOrEffect: QueryGraphAction | QueryGraphEffect
): actionOrEffect is LayoutCalculatedEffect {
    return (actionOrEffect as QueryGraphEffect).effectType === 'LAYOUT_CALCULATED';
}
